import React, { Fragment } from "react";
import styled from "styled-components";
import { connect } from "formik";
import numeral from "numeral";
import { isEmpty, get } from "lodash";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, FormikInputPercent, FormikInputNumber, FormikInputText } from "@loanbossinc/component-library";

const Divider = styled.div`&& {    
    border: 1px solid #DADCE0;
    width: 100%;
    height: 0px;
    margin-top:30px;
}`;

const StyledGridContainer = styled(Grid)`&&{
    margin-top: 26px
}`;
const StyledFormikInputNumber = styled(FormikInputNumber)`&&&&{
    width: 100%
}`;
const StyledFormikInputPercent = styled(FormikInputPercent)`&&&&{
    width: 100%
}`;
const StyledFormikInputText = styled(FormikInputText)`&&&&{
    width: 100%
}`;
const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
    border-bottom: 1px solid #2196F3;
    width: 100%;
`;
const StyledHeaderContainer = styled(Grid)`&&{
    margin-top: 23px;
}`;
const StyledHeader = styled.span`&&{
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;

    color: #000000;
}`;

const getFixedFloating = values => {
  const rateTypeId = get(values, "details.rateTypeId");
  if (rateTypeId && rateTypeId === "53669856-4681-11e9-82f6-0242ac120002") {
    return 1;
  } else if (rateTypeId && rateTypeId === "5813c493-4681-11e9-82f6-0242ac120002") {
    return 2;
  }

  return 0;
};

const FeesSection = ({ formik }) => {
  const { values } = formik;

  const lenders = values && values.ancillary && values.ancillary.lenders ? values.ancillary.lenders : [];
  const loanTypes = values && values.ancillary && values.ancillary.loanTypes ? values.ancillary.loanTypes : [];
  const defaultIndex = getFixedFloating(values);
  const indexes = values && values.ancillary ? defaultIndex == 1 ? values.ancillary.fixedIndexes : values.ancillary.floatingIndexes : [];

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Fees</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={"closingCosts.originationFeePercent"}
          label={"Origination Fee (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={"closingCosts.brokerFeePercent"}
          label={"Broker Fee (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={"closingCosts.otherFeePercent"}
          label={"Other Fees (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <Divider />
    </Grid>
  );
};

export default compose(connect)(FeesSection);
